import React from "react";

const Header = ({ isLoading }) => {
  const handleLogoClick = () => {
    window.location.reload();
  };

  return (
    <header className="flex justify-center items-center p-3 gap-4 bg-gradient-to-t from-[#eeede4] to-[#fbfcf5]">
      <img
        src="logo_notext.png"
        className={`App-logo rounded-[10%] cursor-pointer ${
          isLoading ? "animate-spin" : ""
        }`}
        alt="logo"
        width={70}
        height={70}
        onClick={handleLogoClick}
      />
      <div className="flex flex-col items-start">
        <h1 className="text-5xl font-semibold">TAMPERE</h1>
        <p className="text-[#777] text">Järvivesien lämpötilat</p>
      </div>
    </header>
  );
};

export default Header;
